import React, { useCallback, useState } from "react";

import Address from "@mapmycustomers/shared/types/Address";
import getFormattedAddressForUi from "@mapmycustomers/shared/util/formatters/getFormattedAddressForUi";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { AutoCompleteAddress, AutoCompleteAddressProps, ManualAddress } from "@mapmycustomers/ui";

type Props = Pick<
  AutoCompleteAddressProps,
  "error" | "label" | "onReverseGeocodeAddress" | "required"
> & {
  onChange: (address: string) => void;
  value: string;
};

const Location = ({ error, label, onChange, onReverseGeocodeAddress, required, value }: Props) => {
  const [manualAddress, setManualAddress] = useState<Address>();
  const [isManualAddress, switchToManualAddress, , toggleManualAddress] = useBoolean();

  const handleAddressChange = useCallback(
    (address?: Address) => {
      setManualAddress(address);
      onChange?.(getFormattedAddressForUi(address));
    },
    [onChange]
  );

  return isManualAddress ? (
    <ManualAddress
      error={error}
      label={label}
      onChange={handleAddressChange}
      onReverseGeocodeAddress={onReverseGeocodeAddress}
      onToggleManualAddress={toggleManualAddress}
      required={required}
      value={manualAddress}
    />
  ) : (
    <AutoCompleteAddress
      allowClear
      error={error}
      label={label}
      onChange={handleAddressChange}
      onEnterManually={switchToManualAddress}
      onReverseGeocodeAddress={onReverseGeocodeAddress}
      required={required}
      value={{ address: value }}
    />
  );
};

export default Location;
